// deviceMainImageAdapter — single isolation point for the device MAIN IMAGE batch
// lookup (story 35). Sun serves it in ONE call to keep cost down (contract §9):
//   POST monitoring? no → POST devices/mainImages  (body: [deviceId, ...])
//   auth MONITORING || MOS → 200 Map<deviceId, { deviceId, hasMainImage, documentId,
//   uuid, fileName, extension }>.
//
// The monitoring screen calls this once with all the visible device ids (never one
// request per card) and passes each device its entry down to DeviceHeroImage, which
// only then fetches the cached thumbnail for the devices that actually have an image.
import { apiPost } from '../generic/Api_Functions'

const DEVICE_MAIN_IMAGES_ENDPOINT = 'devices/mainImages'

/**
 * @param {Array<number|string>} deviceIds
 * @returns {Promise<Object>} map keyed by deviceId → main-image info; {} on empty
 *   input or any failure (safe degradation → every card falls back to its type photo).
 */
async function fetchDeviceMainImages (deviceIds = []) {
  if (!Array.isArray(deviceIds) || deviceIds.length === 0) return {}
  try {
    const map = await apiPost(DEVICE_MAIN_IMAGES_ENDPOINT, deviceIds)
    return (map && typeof map === 'object') ? map : {}
  } catch (error) {
    return {}
  }
}

export { DEVICE_MAIN_IMAGES_ENDPOINT, fetchDeviceMainImages }
